// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface SlackConfigOut {}

export const SlackConfigOutSerializer = {
  _fromJsonObject(_object: any): SlackConfigOut {
    return {};
  },

  _toJsonObject(_self: SlackConfigOut): any {
    return {};
  },
};
